"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    high: {
        refreshMargin: 600,
        renderMargin: 300
    },
    normal: {
        refreshMargin: 300,
        renderMargin: 150
    },
    low: {
        refreshMargin: 100,
        renderMargin: 50
    }
};
//# sourceMappingURL=margins-config.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ad-renderer/lib/config/margins-config.js
 ** module id = 464
 ** module chunks = 1
 **/